import { configureStore } from '@reduxjs/toolkit'
import { searchSlice } from './reducers/searchSlice'

export default configureStore({
  reducer: {
    search: searchSlice.reducer,
  },
})